import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/entitlements/entitlementContractHistory/initialState.entitlementContractHistory.data';
import { fetchEntitlementContractHistory as fetchEntitlementContractHistoryAPI } from '../../../../apis/entitlementContractHistoryAPI';
import { updateEntitlementContractHistory as updateEntitlementContractHistoryAPI } from '../../../../apis/entitlementContractHistoryAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_ENTITLEMENT_CONTRACT_HISTORY } from '../../../../constants/actionCreator';

//API to get data by Entitlement Id for Entitlements
export const fetchEntitlementContractHistory = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_CONTRACT_HISTORY.FETCH_ENTITLEMENT_CONTRACT_HISTORY,
  fetchEntitlementContractHistoryAPI
);

//API to update the Entitlement Contract History by EntitlementId
export const updateEntitlementContractHistory = createAsyncThunkWrapper(
  ACTIONS_ENTITLEMENT_CONTRACT_HISTORY.UPDATE_ENTITLEMENT_CONTRACT_HISTORY,
  updateEntitlementContractHistoryAPI
);

const entitlementContractHistorySlice = createSlice({
  name: 'entitlementContractHistory',
  initialState,
  reducers: {
    //Additional Events/Functions capture here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEntitlementContractHistory.pending, (state, action) => {
        handlePending(state, action);
        state.isLoading = true;
        state.entitlementContractHistoryData = [];
        state.isEcontractHistoryResults = null;
      })
      .addCase(fetchEntitlementContractHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.entitlementContractHistoryData = action.payload
          ? action.payload.contractHistoryResult.sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          )
          : [];
        state.eContractHistoryTotalCount = action.payload?.totalRecords
          ? action.payload.totalRecords
          : 0;
        state.isEcontractHistoryResults = action.payload?.country?.length === 0;
        state.updateContractHistoryData.updated = false;
      })
      .addCase(fetchEntitlementContractHistory.rejected, (state, action) => {
        handleRejection(state, action);
        state.isLoading = false;
        state.eContractHistoryTotalCount = 0;
        state.isEcontractHistoryResults = true;
      })
      .addCase(updateEntitlementContractHistory.pending, (state, action) => {
        state.updateContractHistoryLoading = true;
        state.updateContractHistoryData = {};
      })
      .addCase(updateEntitlementContractHistory.fulfilled, (state, action) => {
        state.updateContractHistoryLoading = false;
        state.updateContractHistoryData = action.payload;
      })
      .addCase(updateEntitlementContractHistory.rejected, (state, action) => {
        state.updateContractHistoryLoading = false;
      });
  },
});

export default entitlementContractHistorySlice.reducer;
